// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tip_tip__zteXI","tip-text":"Tip_tip-text__lZCHz","tip--multi":"Tip_tip--multi__NQ5TY"};